module.exports = __webpack_public_path__ + "img/10.4b90470c.png";